export default "__VITE_ASSET__fe692f7b__"